import { useState } from "react";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { api, formatErr } from "@/lib/api";

const EMPTY = { current_password: "", new_password: "", confirm: "" };

export const ChangePassword = () => {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (f.new_password !== f.confirm) return toast.error("Le due nuove password non coincidono");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: f.current_password, new_password: f.new_password });
      toast.success("Password aggiornata");
      setOpen(false);
      setF(EMPTY);
    } catch (e) {
      toast.error(formatErr(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <button data-testid="change-password-open-btn" onClick={() => setOpen(true)} className="flex items-center gap-2 text-xs hover:text-white">
        <KeyRound className="h-3.5 w-3.5" />Cambia password
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="change-password-dialog">
          <DialogHeader><DialogTitle className="font-serif text-2xl">Cambia password</DialogTitle></DialogHeader>
          <div className="space-y-3">
            {[["current_password", "Password attuale"], ["new_password", "Nuova password (min 10 caratteri, lettere e numeri)"], ["confirm", "Ripeti la nuova password"]].map(([k, l]) => (
              <div key={k}><Label>{l}</Label>
                <Input data-testid={`change-password-${k}`} type="password" value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} className="mt-1" /></div>
            ))}
          </div>
          <DialogFooter><Button data-testid="change-password-submit" disabled={busy} onClick={submit} className="bg-navy hover:bg-navy-800">Salva nuova password</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
